import product2 from '../../../assets/images/dashboard-2/product/2.png';
import product3 from '../../../assets/images/dashboard-2/product/3.png';
import product4 from '../../../assets/images/dashboard-2/product/4.png';
import product5 from '../../../assets/images/dashboard-2/product/5.png';

export const TopSellingProductList = [
  {
    title: 'File Jumper Sports Shoes',
    image: product2,
    disc: 20,
  },
  {
    title: 'Adidas Sports Shoes',
    image: product3,
    disc: 28,
  },
  {
    title: 'Puma Green Sports',
    image: product4,
    disc: 42,
  },
  {
    title: 'Grey Nike Air',
    image: product5,
    disc: 41,
  },
];
